/* Haye Nii "Find my size" (snippets/hn-find-size.liquid): the shopper slides to their wrist size and the matching
   Size is picked in the theme's Size dropdown. The window itself opens and closes like the necklace "Size guide"
   (assets/product-options.js: [data-po-guide] opens it, [data-po-guide-close] closes it). */
(function () {
  if (window.hnFindSize) return;
  window.hnFindSize = true;

  function rowsOf(panel) {
    try {
      return JSON.parse(panel.dataset.rows) || [];
    } catch (e) {
      return [];
    }
  }

  // The theme redraws the Size row after every change, so always look the dropdown up again
  function sizeSelect(panel) {
    return document.querySelector('#variant-selects-' + panel.dataset.section + ' select[name="options[Size]"]');
  }

  function letterOf(value) {
    return String(value || '').split(' ')[0];
  }

  // A wrist on a border (e.g. 17.5) gets the bigger size: "Between two sizes? Pick the bigger one."
  function sizeFor(rows, cm) {
    if (cm < rows[0].a) return 'small';
    if (cm > rows[rows.length - 1].b) return 'big';
    var hit = rows[0];
    rows.forEach(function (r) {
      if (cm >= r.a) hit = r;
    });
    return hit;
  }

  function show(panel, choose) {
    var rows = rowsOf(panel);
    var range = panel.querySelector('[data-fs-range]');
    if (!rows.length || !range) return;
    var cm = parseFloat(range.value);
    var pct = ((cm - range.min) / (range.max - range.min)) * 100;
    range.style.setProperty('--fs-pct', pct + '%');
    panel.querySelector('[data-fs-value]').textContent = cm.toFixed(1) + ' cm · ' + (cm / 2.54).toFixed(1) + ' in';

    var size = sizeFor(rows, cm);
    var result = panel.querySelector('[data-fs-result]');
    var done = panel.querySelector('[data-fs-done]');
    if (size === 'small' || size === 'big') {
      var edge = size === 'small' ? 'Smaller than ' + rows[0].s : 'Bigger than ' + rows[rows.length - 1].s;
      result.textContent = edge + "? Message us and we'll help.";
      result.classList.add('is-off');
      range.setAttribute('aria-valuetext', cm.toFixed(1) + ' cm');
      if (done) done.textContent = 'Close';
      return;
    }
    result.classList.remove('is-off');
    result.innerHTML = 'Your size: <strong>' + size.s + '</strong>';
    range.setAttribute('aria-valuetext', cm.toFixed(1) + ' cm, size ' + size.s);
    if (done) done.textContent = 'Use size ' + size.s;
    if (!choose) return;

    var select = sizeSelect(panel);
    if (!select || letterOf(select.value) === size.s) return;
    var option = Array.prototype.filter.call(select.options, function (o) {
      return letterOf(o.value) === size.s;
    })[0];
    if (!option) return;
    panel.dataset.picking = '1';
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Put the slider in the middle of the size that is chosen now
  function follow(panel) {
    var rows = rowsOf(panel);
    var select = sizeSelect(panel);
    var range = panel.querySelector('[data-fs-range]');
    if (!rows.length || !range) return;
    var now = select ? rows.filter(function (r) { return r.s === letterOf(select.value); })[0] : null;
    var size = now || rows[Math.floor((rows.length - 1) / 2)];
    range.value = ((size.a + size.b) / 2).toFixed(1);
    show(panel, false);
  }

  // Opening the window: start at the size that is chosen now
  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-po-guide^="hn-fs-"]');
    if (!opener) return;
    var dialog = document.getElementById(opener.getAttribute('data-po-guide'));
    var panel = dialog && dialog.querySelector('[data-hn-fs]');
    if (panel) follow(panel);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('[data-fs-range]')) return;
    show(event.target.closest('[data-hn-fs]'), true);
  });

  // The shopper picked a size in the dropdown themselves: move the slider to it (only matters while it is open)
  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.closest('variant-selects')) return;
    document.querySelectorAll('[data-hn-fs]').forEach(function (panel) {
      var ours = panel.dataset.picking === '1';
      panel.dataset.picking = '';
      var dialog = panel.closest('dialog');
      if (!ours && dialog && dialog.open) follow(panel);
    });
  });
})();
